export default "__VITE_ASSET__t0JSgdXA__"